import { api } from "../api";

/**
 * findAllDriversByCustomerIdCrudResponse - Function that finds on database all drivers by customer and department as crud response data    
 * /drivers/{customerId}/{departmentId}/{status}    
 * method GET 
 * @async-function
 */
const findAllDriversByCustomerIdCrudResponse = async (token: string, customerId: number, departmentId: number, status: string, page: number, size: number, ignoreDepartments: Boolean = false, search: string = "") => {
    const response = await api.get(
        `/drivers/${customerId}/${departmentId}/${status}?page=${page}&size=${size}&ignoreDepartments=${ignoreDepartments}&search=${search}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};

export default findAllDriversByCustomerIdCrudResponse;